/**
 * Service worker registration helper.
 *
 * Called once from App.js. Intentionally tolerant: if registration fails
 * (private browsing, http-only dev, restricted CSP) we silently skip —
 * the app still works, you just lose offline cache + Android install prompt.
 */

export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Dev server (webpack-dev-server) can serve stale SW chunks that break
  // hot reload. Only register in production + behind https (or localhost).
  const insecure =
    window.location.protocol !== "https:" &&
    window.location.hostname !== "localhost" &&
    window.location.hostname !== "127.0.0.1";
  if (insecure) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .catch((err) => {
        try { console.warn("Service worker registration failed:", err); } catch (_) {}
      });
  });
}
